<script setup lang="ts">
import { ref } from 'vue';

const isMoreOpen = ref(false);

const props = withDefaults(defineProps<{
    linkToWebsite: string;
    needLinkToWebsite?: boolean;
    isLoading?: boolean;
}>(), {
    isLoading: false
});

const emit = defineEmits<{
    (e: 'refreshMetadata'): void;
}>();

const refreshMetadata = () => {
    emit('refreshMetadata');
};

</script>

<template>
  <Popover :is-open="isMoreOpen"
           @update:is-open="(value: boolean) => isMoreOpen = value"
  >
    <template #toggle>
      <button type="button"
              aria-label="more"
              class="display-flex align-items-center justify-center title-link btn-share cursor-pointer"
              @click="isMoreOpen = !isMoreOpen"
      >
        <IconMain :size="25"
                  icon="more"
        />
      </button>
    </template>
    <template #content>
      <div class="more-block share-block display-flex flex-column align-items-start gap-8 with-shadow no-user-select"
           :class="{ 'loading-cursor': isLoading }">
        <div class="display-flex align-items-center justify-center cursor-pointer"
             @click="refreshMetadata">
          <p class="compact-400-accent">
            Refresh metadata
          </p>
        </div>

        <div v-if="props.needLinkToWebsite"
             class="display-flex align-items-center justify-center cursor-pointer">
          <a :href="linkToWebsite"
             target="_blank"
             aria-label="Catalog"
             class="display-flex align-items-center gap-12 link text-decor-none"
          >
            <p class="compact-400-accent">
              Go to website
            </p>
          </a>
        </div>
      </div>
    </template>
  </Popover>
</template>

<style lang="scss">
.more-block {
  width: 153px;

  & > div {
    height: 40px;
  }
}

.with-shadow {
  box-shadow: 0 4px 8px rgb(0 0 0 / 20%);
}

.loading-cursor {
  cursor: wait;

  * {
    cursor: wait;
  }
}

</style>
